import { EventEmitter, Input, Output } from "@angular/core";
import { Component } from "@angular/core";
import { TrackingHistoryListDto } from "../../../core/models/project-workflow/trackingHistoryListDto";
import { TimelineModule } from "primeng/timeline";
import { CommonModule } from "@angular/common";
import { ButtonModule } from "primeng/button";

@Component({
  selector: "jni-tracking-list-popup",
  templateUrl: "./tracking-list-popup.component.html",
  styleUrls: ["./tracking-list-popup.component.scss"],
  // fixes/14757: imports: [TimelineModule, CommonModule],
  imports: [TimelineModule, CommonModule, ButtonModule],
})
export class TrackingListPopupComponent {
  @Input() trackingNumber = "";
  @Input() createdDate = "";
  @Input() trackingHistoryList = [] as TrackingHistoryListDto[];
  @Input() shippingMethodName = "";
  @Input() estDelivery = "";
  @Output() displayChange = new EventEmitter<boolean>();

  onHide() {
    this.displayChange.emit(false);
  }

  get latestStatusHistoryList(): TrackingHistoryListDto[] {
    const latestByStatus = new Map<string, TrackingHistoryListDto>();
    for (const item of this.trackingHistoryList) {
      const existing = latestByStatus.get(item.status);
      if (
        !existing ||
        new Date(item.createdDate) > new Date(existing.createdDate)
      ) {
        latestByStatus.set(item.status, item);
      }
    }
    return Array.from(latestByStatus.values()).sort(
      (a, b) =>
        new Date(b.createdDate).getTime() - new Date(a.createdDate).getTime()
    );
  }
}
